<template lang="pug">
  .enrollment-element
    v-sheet(dark color="secondary").px-8.pt-4.pb-6.overflow-hidden
      v-row(align="center")
        v-col.grow
          .title.mb-4.d-flex.align-center
            v-menu(
              offset-y
              min-width="250"
            )
              template(v-slot:activator="{ on }")
                v-btn(
                  v-on="on"
                  fab
                  text
                  small
                  color="secondary lighten-4"
                ).mr-1
                  v-icon mdi-menu
              v-list(color="secondary lighten-1" dark)
                v-list-item(
                  :to="{ name: 'CourseGroupList', params: { enrollmentId: enrollment.id }}"
                )
                  v-list-item-avatar
                    v-icon mdi-account-multiple
                  v-list-item-content
                    v-list-item-title Список групп
                v-list-item(
                  v-if="$user.isOrganization || isCurator"
                  :to="{ name: 'GroupCreate', params: { enrollmentId: enrollment.id }}"
                )
                  v-list-item-avatar
                    v-icon mdi-plus
                  v-list-item-content
                    v-list-item-title Создать группу
                v-list-item(
                  v-if="$user.isOrganization || isCurator"
                  @click="createChannel"
                )
                  v-list-item-avatar
                    v-icon(size="28") $telegram
                  v-list-item-content
                    v-list-item-title Создать чат набора
            tooltip-wrap(
              text="Код набора"
            )
              strong(v-if="enrollment.code").mr-2 {{ enrollment.code }}
            span {{ course.title }}
          v-expand-transition
            .d-flex(v-if="mode === $conf.ENROLLMENT_MODES.enroll")
              v-card(flat color="transparent")
                v-card-text.d-flex.align-center
                  v-icon(color="secondary lighten-4" large).mr-2 mdi-calendar
                  v-sheet(color="transparent").caption.opacity-15
                    div
                      strong {{ enrollment.period_start | dp('d MMMM yyyy') }}
                      span  - начало набора
                    div
                      strong  {{ enrollment.period_end | dp('d MMMM yyyy') }}
                      span  - окончание набора
          v-expand-transition
            .d-flex(v-if="mode === $conf.ENROLLMENT_MODES.education")
              v-card(flat color="transparent")
                v-card-text.d-flex.align-center
                  v-icon(color="secondary lighten-4" large).mr-2 mdi-calendar
                  v-sheet(color="transparent").caption.opacity-15
                    div
                      strong {{ enrollment.start_learning | dp('d MMMM yyyy') }}
                      span  - начало обучения
                    div
                      strong  {{ enrollment.end_learning | dp('d MMMM yyyy') }}
                      span  - окончание обучения
          .mb-n2
            v-btn-toggle(
              v-model="mode"
              :mandatory="!!mode"
            ).mt-1
              v-btn(
                color="#525164"
                :to=`{
                  name: 'CourseEnrollmentSettings',
                  params: { enrollmentId: enrollment.id, courseId: course.id }
                }`
                :value="$conf.ENROLLMENT_MODES.settings"
              ).px-5
                v-icon(left) mdi-cog
                span Настройки
              v-btn(
                color="#525164"
                :to=`{
                  name: 'CourseEnrollmentRecords',
                  params: { enrollmentId: enrollment.id, courseId: course.id }
                }`
                :value="$conf.ENROLLMENT_MODES.enroll"
              ).px-5
                v-icon(left) mdi-account
                span Зачисление
                strong(v-if="stats.waitForEnrollUsers").ml-2 +{{ stats.waitForEnrollUsers }}
              v-btn(
                color="#525164"
                :to=`{
                  name: 'CourseEnrollmentAttestation',
                  params: { enrollmentId: enrollment.id, courseId: course.id }
                }`
                :value="$conf.ENROLLMENT_MODES.education"
              ).px-5
                v-icon(left) mdi-account-school-outline
                span Аттестация

        v-col.shrink
          v-sheet(min-width=200 color="transparent")
            .my-4(
              v-if="enrollment.end_learning"
            )
              .d-flex.align-center.fill-height.caption
                template(v-if="isNotStartedEnrollment")
                  v-icon(color="secondary lighten-4").mr-4 mdi-timeline-alert-outline
                  v-sheet(color="transparent").opacity-15
                    span До начала набора
                    div: strong {{ enrollment.period_start | dateprint_from_now }}
                template(v-if="isActiveEnrollment")
                  v-icon(color="secondary lighten-4").mr-4 mdi-timeline-clock-outline
                  v-sheet(color="transparent").opacity-15
                    span До окончания набора
                    div: strong {{ enrollment.period_end | dateprint_from_now }}
                template(v-if="isEndedEnrollment")
                  v-icon(color="success").mr-4 mdi-timeline-check-outline
                  v-sheet(color="transparent").opacity-15
                    span Набор завершен
            .my-4(
              v-if="enrollment.end_learning"
            )
              .d-flex.align-center.fill-height.caption.nowrap
                template(v-if="isNotStartedEducation")
                  v-icon(color="secondary lighten-4").mr-4 mdi-timeline-alert-outline
                  v-sheet(color="transparent").opacity-15
                    span До начала обучения
                    div: strong {{ enrollment.start_learning | dateprint_from_now }}
                template(v-if="isActiveEducation")
                  v-icon(color="secondary lighten-4").mr-4 mdi-timeline-clock-outline
                  v-sheet(color="transparent").opacity-15
                    span До окончания обучения
                    div: strong {{ enrollment.end_learning | dateprint_from_now }}
                template(v-if="isEndedEducation")
                  v-icon(color="success").mr-4 mdi-timeline-check-outline
                  v-sheet(color="transparent").opacity-15
                    span Обучение завершено
              //- template(v-if="mode === $conf.ENROLLMENT_MODES.enroll")
              //-   v-progress-linear(
              //-     :value="recordedUsers.percent"
              //-     color="success"
              //-     height="20"
              //-     rounded
              //-   ).mt-4
              //-   .caption.opacity-15.mt-1
              //-     | {{ recordedUsers.count }}/{{ enrollment.number_place }} зачислено

    slot
      v-card
        v-card-text
          v-list
            v-list-item
              v-list-item-content
                v-list-item-title.mb-2 Набор
                v-list-item-subtitle с {{ enrollment.period_start | dp('d MMMM yyyy') }}
                v-list-item-subtitle по {{ enrollment.period_end | dp('d MMMM yyyy') }}
              v-list-item-content
                v-list-item-title.mb-2 Обучение
                v-list-item-subtitle с {{ enrollment.start_learning | dp('d MMMM yyyy') }}
                v-list-item-subtitle по {{ enrollment.end_learning | dp('d MMMM yyyy') }}
            v-list-item.d-flex.mt-3
              v-btn(
                color="secondary"
                depressed
                @click="$emit('edit')"
              ) Редактировать
              v-btn(
                color="error darken-1"
                depressed
                outlined
                @click="$emit('delete')"
              ).ml-2 Удалить
</template>

<script>
export default {
  name: 'EnrollmentElement',
  props: {
    enrollment: { type: Object, required: true },
    course: { type: Object, required: true },
    stats: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      curatorIds: [],
      mode: null,
    };
  },
  computed: {
    isCurator() {
      return this.curatorIds.includes(this.$user.data.id);
    },
    waitForEnrollUsers() {
      return 0;
    },
    recordedUsers() {
      // const count = this.users.items.length - this.waitForEnrollUsers.length;
      const count = this.stats.recorded;
      return {
        count,
        percent: (100 / this.enrollment.number_place) * count,
      };
    },
    isEndedEducation() {
      const endDate = new Date(this.enrollment.end_learning);
      return endDate < new Date();
    },
    isNotStartedEducation() {
      const startDate = new Date(this.enrollment.start_learning);
      return startDate > new Date();
    },
    isActiveEducation() {
      return !this.isEndedEducation && !this.isNotStartedEducation;
    },
    isEndedEnrollment() {
      const endDate = new Date(this.enrollment.period_end);
      return endDate < new Date();
    },
    isNotStartedEnrollment() {
      const startDate = new Date(this.enrollment.period_start);
      return startDate > new Date();
    },
    isActiveEnrollment() {
      return !this.isEndedEnrollment && !this.isNotStartedEnrollment;
    },
  },
  async created() {
    const { items } = await this.$api.users.index({
      'search[curator_course_id]': this.course.id,
    });
    this.curatorIds = items.map((i) => i.id);
  },
  methods: {
    async createChannel() {
      await this.$api.telegram.enrollmentChannel(this.enrollment.id);
      this.$toasted.success('Успешно');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

::v-deep .enrollment-sheet {
  overflow-y: scroll;
  height: calc(100vh - 370px);

  @include sdo-dark-scrollbar();
}

.opacity-15 {
  opacity: .75;
}
</style>
